// 
import React, { useEffect } from "react";
import "../PaymentDialogues/PaymentDialogue.scss";

import {  Dialog, DialogContent } from "@mui/material";

import PaypalLogo from "../../assets/images/vactor/paypal-logo.svg"
import {  useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { capturePaypalPayment } from "../../Services/payment.service";
import { openSnackbar } from "../../Slice/snackbarSlice";
import { setIsPaymentDone } from "../../Slice/userSlice";

const PaymentProcessing = () => {
  const [open, setOpen] = React.useState(true);
  const navigate = useNavigate();
  const user = useAppSelector(state=>state.user);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const payerId = searchParams.get("PayerID");
  const requestBody={
    token:token,
    payer_id:payerId
  }
  
  useEffect(() => {
    if (token && payerId) {
      dispatch(capturePaypalPayment(requestBody))
        .unwrap()
        .then((res) => {
          if(!res.status){
            navigate("/payment/failure");
          }else{
          dispatch(openSnackbar({message:"Payment succesfull",severity:"success"}));
           
          setTimeout(()=>{
            dispatch(setIsPaymentDone());
            navigate("/dashboard");
          },1000)
         
          }
        })
        .catch((err) => {
          navigate("/payment/failure");
        });
    }
  }, []);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="alert-dialog-wrapper">
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              handleClose();
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="alert-dialog"
          disableEscapeKeyDown
        >
          <DialogContent>
            <div className="upgrade-dialog-body">
              <div className="upgrade-icon">
                <img src={PaypalLogo} alt="PaypalRound" /> 
              </div>
              <div className="upgrade-dialog-title">Processing Payment...</div>
              <div className="upgrade-dialog-dsc">
                Please wait while we confirm your payment with PayPal. This will only take a moment
              </div>
              <div className="loading-spinner">
                <div className="spinner">
                  <div className="bounce1 dots"></div>
                  <div className="bounce2 dots"></div>
                  <div className="bounce3 dots"></div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default PaymentProcessing;
